/**
 * Розподіл варіантів сегментованого перемикача (UIUX controls/segmented-control: «More than 8 options go into a dropdown»): до 8 — усі
 * сегментами; більше — перші 7 сегментами, решта — у списку «Ще…» (вибраний варіант зі списку лишається видно в ньому). Чиста функція.
 */
export const SEGMENTS_MAX = 8;

export function segmentedSplit<T>(options: readonly T[]): { shown: T[]; more: T[] } {
  if (options.length <= SEGMENTS_MAX) return { shown: [...options], more: [] };
  return { shown: options.slice(0, SEGMENTS_MAX - 1), more: options.slice(SEGMENTS_MAX - 1) };
}
